import { usePageSectionsStore } from '@/Stores/Web/pageSectionsStore';

import router from '@/Router';
import MagicAnchor from '@/Plugins/MagicAnchor.js';
import { slugify } from '@/Utils/StringUtility';

router.addRoute({
    path: '/section/:section/:subSection?',
    name: 'page-section',
    component: { render: () => null },
    meta: { noScroll: true },
});

let lastTopLevelSection = null;
let fallbackSectionIndex = 0;

export default class PageSectionAnchor {
    constructor(anchorElement, name, urlName, isTopLevel, anchorScrollOffset = null) {
        const sectionUrlName = slugify(urlName) || slugify(name, `section-${ ++fallbackSectionIndex }`);

        addPageSection(name, sectionUrlName, isTopLevel || !lastTopLevelSection);

        const anchorRoute = {
            name: 'page-section',
            params: isTopLevel || !lastTopLevelSection
                ? { section: sectionUrlName }
                : { section: lastTopLevelSection.urlName, subSection: sectionUrlName },
        };

        new MagicAnchor(anchorElement, anchorRoute, anchorScrollOffset);
    }
}

function addPageSection(name, urlName, isTopLevel) {
    const section = {
        name,
        urlName,
        sections: [],
    };

    const pageSectionStore = usePageSectionsStore();
    pageSectionStore.addPageSection({ section, parentSection: isTopLevel ? null : lastTopLevelSection });

    if (isTopLevel)
        lastTopLevelSection = section;

    return section;
}